// @flow
import get from 'lodash/get';
import defaultState from '../../state';
import { HIDE_SOURCES_LOADER, SHOW_SOURCES_LOADER } from './actionTypes';
import { SOURCES_MODULE_NAME, LOADER_STATE_NAME } from '../constants';

type State = {
  isShow: boolean,
};

export const initialState: State = get(defaultState, [SOURCES_MODULE_NAME, LOADER_STATE_NAME]);

export default (state: State = initialState, action: TrovitAction): Object => {
  switch (action.type) {
    case SHOW_SOURCES_LOADER:
      return {
        ...state,
        isShow: true,
      };
    case HIDE_SOURCES_LOADER:
      return {
        ...state,
        isShow: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/Sources/loader/reducer.js